import { useEffect, useRef, useState } from "react";

const inputCls = "bg-[#0F0F0F] border border-white/10 text-white text-sm px-3 py-2.5 rounded-sm focus:outline-none focus:border-[#D4AF37] w-full";

export const PlayerPicker = ({ players, value, onChange }) => {
  const [query, setQuery] = useState("");
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const close = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, []);

  const selected = players.find((p) => p.player_id === value);
  const filtered = players.filter((p) =>
    `${p.player_id} ${p.name}`.toLowerCase().includes(query.toLowerCase())).slice(0, 12);

  return (
    <div ref={ref} className="relative lg:col-span-2">
      <input
        placeholder="Type to search player *"
        value={open ? query : (selected ? `${selected.player_id} — ${selected.name}` : query)}
        onChange={(e) => { setQuery(e.target.value); onChange(""); setOpen(true); }}
        onFocus={() => { setQuery(""); setOpen(true); }}
        className={inputCls}
        data-testid="pay-player-search"
      />
      {open && (
        <div className="absolute z-30 left-0 right-0 top-full mt-1 bg-[#0F0F0F] border border-white/15 max-h-56 overflow-y-auto" data-testid="pay-player-list">
          {filtered.length === 0 && <p className="text-white/40 text-xs p-3">No players match "{query}"</p>}
          {filtered.map((p) => (
            <button key={p.player_id} type="button"
              onClick={() => { onChange(p.player_id); setQuery(`${p.player_id} — ${p.name}`); setOpen(false); }}
              className="w-full text-left px-3 py-2.5 text-sm text-white/80 hover:bg-[#D4AF37]/10 hover:text-[#D4AF37] transition-colors duration-100"
              data-testid={`pay-option-${p.player_id}`}>
              <span className="text-[#D4AF37] text-xs mr-2">{p.player_id}</span>{p.name}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
